import React from "react";

export const EyeIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512' fill='currentColor' width='1em' height='1em'>
    <path d='M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z' />
  </svg>
);

export const STDCEyeIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor' width='1em' height='1em' aria-hidden='true' className='h-6 w-6 text-inaqpurple'>
    <path d='M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' />
  </svg>
);

export const CreditCardIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256' fill='currentColor' width='1em' height='1em'>
    <path d='M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM136,168H72a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm56,0H176a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16ZM32,112V88a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8v24Z' />
  </svg>
);

export const LightbulbIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512' fill='currentColor' width='1em' height='1em' aria-hidden='true' className='h-6 w-6 text-inaqpurple'>
    <path d='M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z' />
  </svg>
);

export const CreditCardFrontFillIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512' fill='currentColor' width='1em' height='1em' aria-hidden='true' className='h-5 w-6 text-inaqpurple'>
    <path d='M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 224h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-128-64h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z' />
  </svg>
);

export const LoyaltyIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor' width='1em' height='1em' aria-hidden='true' className='h-6 w-6 text-inaqpurple'>
    <path d='M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27A2.5 2.5 0 0 1 8 13.24l3-3a2.5 2.5 0 0 1 2.83-.39l4.27 4.27c.3.3.3.79 0 1.09z' />
  </svg>
);

export const CheckCircleIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' fill='currentColor' width='1em' height='1em' className='text-gray-500 text-xl flex-shrink-0 group-hover:text-[#6a604d]'>
    <path d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z' />
  </svg>
);

export const STDC_ICON_MAP = {
  eye: STDCEyeIcon,
  lightbulb: LightbulbIcon,
  creditCard: CreditCardFrontFillIcon,
  loyalty: LoyaltyIcon,
};

export const FLOATING_ICON_MAP = {
  eye: EyeIcon,
  creditcard: CreditCardIcon,
  creditCard: CreditCardIcon,
  lightbulb: LightbulbIcon,
  loyalty: LoyaltyIcon,
  check: CheckCircleIcon,
};
